import { createSlice } from '@reduxjs/toolkit';

export const adminOnboardingSlice = createSlice({
  name: 'adminOnboarding',
  initialState: {
    password: '',
    newpassword: '',
    pin: '',
    onboard_did_numbers: [],
    users: {},
    onboard_user_details: [],
    onboard_company_details: [],
    onboard_company_address: [],
    onboard_extensions: [],
    direct_number: '',
    admin_did_display: '',
    total_user_purchased: 0,
    total_licensed_user: 0,
    total_unlicensed_user: 0,
    call_forwarding_list: [],
    onboarding_url: "",
    url_data: ""
  },
  reducers: {
    setOnboardingURL: (state, action) => {
      state.onboarding_url = action.payload;
    },
    setURLData: (state, action) => {
      state.url_data = action.payload;
    },
    setOnboardDidNumbers: (state, action) => {
      state.onboard_did_numbers = action.payload;
    },
    setOnboardCompanyDetails: (state, action) => {
      state.onboard_company_details = action.payload;
    },
    setOnboardCompanyAddress: (state, action) => {
      state.onboard_company_address = action.payload;
    },
    setOnboardUserDetails: (state, action) => {
      state.onboard_user_details = action.payload;
    },
    setOnboardExtensions: (state, action) => {
      state.onboard_extensions = action.payload;
    },
    setOnboardDirectNumber: (state, action) => {
      state.direct_number = action.payload;
    },
    setOnboardAdminDidDisplay: (state, action) => {
      state.admin_did_display = action.payload;
    },
    setOnboardTotalUserPurchased: (state, action) => {
      state.total_user_purchased = action.payload;
    },
    setOnboardTotalLicensedUser: (state, action) => {
      state.total_licensed_user = action.payload;
    },
    setOnboardTotalUnLicensedUser: (state, action) => {
      state.total_unlicensed_user = action.payload;
    }
  }
});

export const {
  setOnboardingURL,
  setURLData,
  setOnboardDidNumbers,
  setOnboardCompanyDetails,
  setOnboardCompanyAddress,
  setOnboardUserDetails,
  setOnboardExtensions,
  setOnboardDirectNumber,
  setOnboardAdminDidDisplay,
  setOnboardTotalUserPurchased,
  setOnboardTotalLicensedUser,
  setOnboardTotalUnLicensedUser
} = adminOnboardingSlice.actions

export default adminOnboardingSlice.reducer;